"use strict";
exports.__esModule = true;
exports.Surveys = void 0;
var nodeDefs_1 = require("./nodeDefs");
var refsData_1 = require("./refsData");
var getCategoryByName = function (params) {
    var survey = params.survey, categoryName = params.categoryName;
    return survey.categories
        ? Object.values(survey.categories).find(function (category) { return category.props.name === categoryName; })
        : undefined;
};
var getTaxonomyByName = function (params) {
    var survey = params.survey, taxonomyName = params.taxonomyName;
    return survey.taxonomies
        ? Object.values(survey.taxonomies).find(function (taxonomy) { return taxonomy.props.name === taxonomyName; })
        : undefined;
};
exports.Surveys = {
    getNodeDefByName: nodeDefs_1.getNodeDefByName,
    getNodeDefByUuid: nodeDefs_1.getNodeDefByUuid,
    getNodeDefChildren: nodeDefs_1.getNodeDefChildren,
    getNodeDefParent: nodeDefs_1.getNodeDefParent,
    getNodeDefRoot: nodeDefs_1.getNodeDefRoot,
    getNodeDefSource: nodeDefs_1.getNodeDefSource,
    isNodeDefAncestor: nodeDefs_1.isNodeDefAncestor,
    getCategoryByName: getCategoryByName,
    getCategoryItemByCodePaths: refsData_1.getCategoryItemByCodePaths,
    getCategoryItemByUuid: refsData_1.getCategoryItemByUuid,
    getTaxonByCode: refsData_1.getTaxonByCode,
    getTaxonByUuid: refsData_1.getTaxonByUuid,
    getTaxonomyByName: getTaxonomyByName
};
//# sourceMappingURL=index.js.map